module.exports = __webpack_public_path__ + "img/logo.5cf119b8.jpg";